import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAccessRoute: InvariantJiraRoute = {
	name: 'project-settings-core-access',
	path: '/jira/core/projects/:projectKey/settings/access',
	exact: true,
};
